import { combineReducers } from 'redux';
import editCourse from './editCourse';
import groupsRegister from './groupsRegister';
import inputTime from './inputTime';
import liveProjectReducer from './liveProjectReducer';
import loginReducer from './loginReducer';
import session from './session';
const { routerReducer } = require('react-router-redux');

const rootReducer:any = combineReducers({
  session,
  inputTime,
  editCourse,
  groupsRegister,
  liveProjectReducer,
  loginReducer,
  routing: routerReducer,
});

export default rootReducer;
